"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userReducer = exports.authReducer = void 0;
var entries_1 = __importDefault(require("lodash/entries"));
var get_1 = __importDefault(require("lodash/get"));
var actions_1 = require("./actions");
// eslint-disable-next-line @typescript-eslint/default-param-last
function authReducer(state, action) {
    if (state === void 0) { state = { error: false, loading: true }; }
    var type = action.type, props = __rest(action, ["type"]);
    switch (type) {
        case actions_1.DISABLE_AUTHENTICATION:
            return __assign(__assign({}, state), { error: false, loading: false, authenticationDisabled: true });
        case actions_1.AUTH_INIT:
        case actions_1.AUTH_SUCCESS:
        case actions_1.AUTH_REFRESH_SUCCESS:
            return __assign(__assign(__assign({}, state), props), { error: false, loading: false });
        case actions_1.AUTH_REFRESH_ERROR:
            return __assign(__assign({}, state), { error: true, loading: false });
        case actions_1.AUTH_ERROR:
            return __assign(__assign({}, state), { error: true, loading: false });
        case actions_1.AUTH_LOGOUT:
            return __assign(__assign({}, state), { error: false, loading: false });
        default:
            return state;
    }
}
exports.authReducer = authReducer;
// eslint-disable-next-line @typescript-eslint/default-param-last
function userReducer(state, action) {
    if (state === void 0) { state = { authenticated: false }; }
    switch (action.type) {
        case actions_1.AUTH_SUCCESS:
        case actions_1.AUTH_REFRESH_SUCCESS: {
            var idTokenParsed = action.idTokenParsed;
            return {
                authenticated: true,
                userName: idTokenParsed.preferred_username,
                fullName: idTokenParsed.name || idTokenParsed.preferred_username,
                roles: getRoles(action.tokenParsed),
            };
        }
        case actions_1.AUTH_ERROR:
            return { authenticated: false };
        case actions_1.AUTH_LOGOUT:
            return { authenticated: false };
        default:
            return state;
    }
}
exports.userReducer = userReducer;
function getRoles(token) {
    var realmRoles = (0, get_1.default)(token, 'realm_access.roles', []);
    var clientRoles = (0, entries_1.default)((0, get_1.default)(token, 'resource_access', {}))
        .map(function (_a) {
        var clientName = _a[0], client = _a[1];
        return (0, get_1.default)(client, 'roles', [])
            .map(function (role) { return "".concat(clientName, ":").concat(role); });
    })
        .reduceRight(function (v, acc) { return acc.concat(v); }, []);
    return __spreadArray(__spreadArray([], realmRoles, true), clientRoles, true);
}
